import { z } from "zod";

export const financialsSourceEnum = z.enum([
  "freeagent",
  "xero",
  "quickbooks",
  "sage",
  "freshbooks",
  "manual",
  "calculated",
]);
export type FinancialsSource = z.infer<typeof financialsSourceEnum>;

/** Mirrors Sidequester `company_financials` (id 455). One row per company per tax year. */
export const companyFinancialsSchema = z.object({
  id: z.number().int(),
  company_id: z.number().int(),
  tax_year: z.string(),
  revenue: z.number().default(0),
  cost_of_sales: z.number().default(0),
  gross_profit: z.number().default(0),
  operating_expenses: z.number().default(0),
  staff_costs: z.number().default(0),
  net_profit: z.number().default(0),
  corporation_tax: z.number().default(0),
  retained_profit: z.number().default(0),
  total_dividends_paid: z.number().default(0),
  total_bik: z.number().default(0),
  total_pension_contributions: z.number().default(0),
  total_dla_balance: z.number().default(0),
  vat_collected: z.number().default(0),
  vat_paid: z.number().default(0),
  vat_liability: z.number().default(0),
  cash_in_bank: z.number().default(0),
  total_assets: z.number().default(0),
  total_liabilities: z.number().default(0),
  source: financialsSourceEnum.default("manual"),
  // Xano returns timestamps as epoch-ms numbers; some endpoints serialise as ISO strings.
  synced_at: z.union([z.string(), z.number()]).nullable().optional(),
  created_at: z.union([z.string(), z.number()]),
  updated_at: z.union([z.string(), z.number()]),
});
export type CompanyFinancials = z.infer<typeof companyFinancialsSchema>;
